import { useEffect, useRef, useState } from "react";
import { HERO_VIDEO, HERO_VIDEO_MOBILE } from "@/lib/constants";

const BOX = "absolute inset-x-0 top-0 w-full aspect-[3/4] md:aspect-auto md:h-[92vh] md:max-h-[860px]";
const MEDIA = `${BOX} object-cover md:object-contain object-center`;

export function HeroBackground() {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);
  const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const mobile = typeof window !== "undefined" && window.innerWidth < 768;
  const src = mobile && HERO_VIDEO_MOBILE ? HERO_VIDEO_MOBILE : HERO_VIDEO;
  const poster = mobile ? "/brand/hero-loop-poster-mobile.jpg" : "/brand/hero-loop-poster.jpg";
  useEffect(() => { ref.current?.play?.().catch(() => {}); }, [src]);
  return (
    <>
      <img src="/brand/hero-loop-blur.jpg" alt="" aria-hidden="true" className={`${BOX} hidden md:block object-cover scale-110 blur-xl opacity-80`} />
      <img src={poster} alt="Aerial view of a beachfront home and Pacific beach in Nicaragua" className={MEDIA} data-testid="hero-bg-image" />
      {src && !reduce && (
        <video ref={ref} key={src} poster={poster} autoPlay muted loop playsInline preload="auto" aria-hidden="true"
          onCanPlay={() => setReady(true)} className={`${MEDIA} transition-opacity duration-1000 ${ready ? "opacity-100" : "opacity-0"}`} data-testid="hero-bg-video">
          <source src={src.replace(/\.mp4$/, ".webm")} type="video/webm" />
          <source src={src} type="video/mp4" />
        </video>
      )}
    </>
  );
}
